// import moment from 'moment';
import { getPermissionFilter } from "@/utils/auth"; // get token from cookie

export function toThousand(num, decimal = 0, preffix = "") {
  if (
    num === undefined ||
    num === null ||
    num === "null" ||
    num === "-" ||
    num === ""
  )
    return "-";
  num = Number(+num || 0).toFixed(decimal);
  let preffixChar = preffix;
  if (typeof preffix === "boolean") {
    preffixChar = Number(num) === 0 ? "" : Number(num) >= 0 ? "+" : "-";
    num = num.replace(preffixChar, "");
  }
  return (
    preffixChar +
    num.replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","))
  );
}

export function toPercent(
  num,
  decimal = 0,
  preffix = false,
  suffix = "%",
  multiple = 1
) {
  if (
    num === undefined ||
    num === null ||
    num === "null" ||
    num === "-" ||
    num === ""
  )
    return "-";
  if (typeof num === "string" && num.indexOf("%") > -1)
    num = num.replace("%", "");
  let str = Number(num * multiple).toFixed(decimal);
  if (preffix) {
    const preffixChar = Number(num) === 0 ? "" : Number(num) >= 0 ? "+" : "-";
    str = preffixChar + str.replace(preffixChar, "");
  }
  return str + suffix;
}

export function isPlusOrMinus(num) {
  if (Number.isNaN(num) && typeof num === "string") {
    num = num.replace(/[\+|%]/g, "");
  }
  if (num === null || num === undefined || num === "-") return null;
  return Number(num) >= 0 ? 1 : -1;
}
/**
 * 验证是否有行业政策和行政新闻是否有个别页面进行显示
 */
export function PermissionFilterBl(fullPath) {
  let PermissionFilter = getPermissionFilter(); // 用于部分页面需要越权显示使用
  PermissionFilter = PermissionFilter ? JSON.parse(PermissionFilter) : [];
  return Boolean(PermissionFilter.find(e => e.path === fullPath));
}
